// extracted by mini-css-extract-plugin
var _1 = "ApplicantMatchingWidgetContent-moduleApplicantMatchingWidgetContent__G1rbb";
export { _1 as "ApplicantMatchingWidgetContent" }
